import React from "react"
import InsightsCardPhoto from "./insights-card-photo";
import InsightsCard from "./insights-card";
import Pagination from "../common/pagination";

const InsightsFeed = ({data, pageContext}) => {

    let date = new Date();
    let day = date.getUTCDate();
    let dayConditional = day % 2 !== 0;
    let counterPrinted = 0;
    let cardToPrint = dayConditional ? 'InsightCard' : 'InsightCardPhoto';

    return (
        <section className="position-relative py-8 py-md-11 mb-9">

            {/** Content */}
            <div className="container">
                <div className="row align-items-center">

                    {data.allStrapiArticle.edges.map((document, i) => {
                        if (dayConditional && i === 0) {
                            return <InsightsCardPhoto article={document.node} key={i}/>
                        }

                        if (!dayConditional && i === 0) {
                            return <InsightsCard article={document.node} key={i}/>
                        }

                        if (counterPrinted <= 2 && cardToPrint === 'InsightCard') {
                            counterPrinted++

                            if (counterPrinted === 2) {
                                cardToPrint = 'InsightCardPhoto';
                                counterPrinted = 0;
                            }

                            return <InsightsCard article={document.node} key={i}/>
                        } else {
                            counterPrinted++

                            if (counterPrinted === 2) {
                                cardToPrint = 'InsightCard';
                                counterPrinted = 0;
                            }

                            return <InsightsCardPhoto article={document.node} key={i}/>
                        }
                    })}

                    <Pagination pageContext={pageContext}/>

                </div>
                {/** / .row */}
            </div>
            {/** / .container */}
        </section>
    )
}

export default InsightsFeed
